import React from 'react';
import { Dealer } from 'domains/Dealer';
import * as Styled from 'components/DealerPage/components/DealerHours/DealerHours.styled';

export interface DealerHoursProps {
  dealer: Dealer;
  onToggleHours: () => void;
  isHoursOpen: boolean;
}

const DealerHours = ({
  dealer,
  onToggleHours,
  isHoursOpen,
}: DealerHoursProps) => {
  const dealerOpen =
    dealer.workingHours &&
    dealer.workingHours.find((item) => item.isCurrentOpen);

  const isCurrentlyOpen = dealerOpen?.isCurrentOpen ?? false;

  return (
    <Styled.HoursWrapper>
      <Styled.DealerContactStatus onClick={onToggleHours}>
        <Styled.ListItemOpen isOpen={isCurrentlyOpen}>
          {isCurrentlyOpen ? 'Open Now' : 'Closed Now'}
        </Styled.ListItemOpen>
        <Styled.ListItemTitle isBold={true}>
          {dealer.hasAppointmentOnly
            ? 'By appointment only'
            : dealerOpen && dealerOpen.openTime && dealerOpen.closeTime
            ? `${dealerOpen.openTime} - ${dealerOpen.closeTime}`
            : 'See opening hours'}
          {!dealer.hasAppointmentOnly && (
            <Styled.DealerChevron
              $isMenuOpen={isHoursOpen}
              height={16}
              width={16}
              $isDisabled={false}
            />
          )}
        </Styled.ListItemTitle>
      </Styled.DealerContactStatus>
      {isHoursOpen && (
        <Styled.ListWrapper data-testid="h2-details-text">
          {dealer.workingHours?.map((item) => {
            return (
              <Styled.ListItem
                key={`${dealer.id}-${item.day}`}
                isOpen={item.isCurrentOpen && !item.appointmentOnly}
              >
                <Styled.ListItemOpenHours
                  isOpen={item.isCurrentOpen && !item.appointmentOnly}
                >
                  {item.day}
                </Styled.ListItemOpenHours>
                {item.appointmentOnly && item.appointmentOnlyText && (
                  <Styled.ListItemOpen isOpen={false}>
                    {item.appointmentOnlyText}
                  </Styled.ListItemOpen>
                )}
                {item.openTime && item.closeTime && !item.appointmentOnly ? (
                  <Styled.ListItemOpenHours isOpen={item.isCurrentOpen}>
                    {item.openTime} to {item.closeTime}
                  </Styled.ListItemOpenHours>
                ) : (
                  !item.isCurrentOpen &&
                  !item.appointmentOnly && (
                    <Styled.ListItemOpen isOpen={item.isCurrentOpen}>
                      Closed
                    </Styled.ListItemOpen>
                  )
                )}
              </Styled.ListItem>
            );
          })}
        </Styled.ListWrapper>
      )}
    </Styled.HoursWrapper>
  );
};

export { DealerHours };
